import { useAppSelector } from "../../app/hooks";
import React, { useEffect, useState } from "react";
import { convertDevicesToPixPolygons } from "../../DesignTab/devices/deviceUtils";
import { generateRandomString, PartialMcBimSpace } from "../../utils";
import { convertMcBimSpaceToPixPolygon } from "../../DesignTab/pixpolygonSelectors";
import { DeckBimViewer } from "@multiconsult-group/multiplacer-ui";
import { IFireDeviceSquareBoxesWithCoversValidation } from "./fireDeviceValidations.utils";
import { ActionIcon, Flex, Stack } from "@mantine/core";
import { FaArrowAltCircleLeft, FaArrowAltCircleRight } from "react-icons/fa";
import { IPixPolygon } from "@multiconsult-group/multiplacer-ui";
import { getCombinationOfFireDeviceSquares } from "./spaceValidationsUtils";
import { DeviceCategoryEnum } from "@multiconsult-group/multiplacer-core";
import { useGetMcbimSingleMcbimSpaceQuery } from "../../../openapi";
import { selectHttpDevicesInRoom } from "../../DesignTab/devices/deviceSlice";

const SprinklerSquareWallRuleViewer: React.FC = () => {
  const [selectedCombinationIndex, setSelectedCombinationINdex] = useState<number>(0);
  const selecedSpaceNumber = useAppSelector((state) => state.design.selectedSpaceNumber);

  const projectNo = useAppSelector((state) => state.design.projectNo);

  const rotation = useAppSelector((state) => state.design.rotation);

  const { data: mcbimSpace } = useGetMcbimSingleMcbimSpaceQuery({
    name: selecedSpaceNumber as string,
    projectNo: projectNo,
  });

  const devicesInRoom = useAppSelector(selectHttpDevicesInRoom);

  const devicesAsPixPolygons = convertDevicesToPixPolygons({
    devices: devicesInRoom?.filter(
      (device) => device.deviceCategory === DeviceCategoryEnum.FIRE_SUPPRESSION_DEVICE
    ),
    typeDevices: [],
    selectedDeviceId: null,
    hideDevices: false,
    showTrueSize: false,
    isMoveable: false,
  });

  const spacePixPolygon = convertMcBimSpaceToPixPolygon({
    mcBimSpace: mcbimSpace as PartialMcBimSpace,
    dragSelectSpaces: false,
  });

  // const pixPaths =
  //   hasCeiling && room != null && mcbimSpace != null
  //     ? getPixPolygonCeilingGrids({
  //         mcbimSpace: mcbimSpace,
  //         room: room,
  //       })
  //     : [];

  const combinationOfFireDeviceSquares = React.useMemo(() => {
    return mcbimSpace != null
      ? getCombinationOfFireDeviceSquares({
          devicesInRoom: devicesInRoom,
          mcbimSpace: mcbimSpace,
        })
      : [];
  }, [mcbimSpace, devicesInRoom]);

  useEffect(() => {
    const validIndex = combinationOfFireDeviceSquares.findIndex((comb) => comb.coverAllWalls);
    if (validIndex !== -1) {
      setSelectedCombinationINdex(validIndex);
    } else {
      setSelectedCombinationINdex(0);
    }
  }, [combinationOfFireDeviceSquares, selecedSpaceNumber]);

  const combinationOfFireDeviceSquaresPixPolygons = React.useMemo(() => {
    return combinationOfFireDeviceSquares?.length > 0
      ? convertFireDeviceSquareBoxesToPixPolygons(
          combinationOfFireDeviceSquares[selectedCombinationIndex]
        )
      : [];
  }, [combinationOfFireDeviceSquares, selectedCombinationIndex, selecedSpaceNumber]);

  const allPixPolygons = React.useMemo(() => {
    return spacePixPolygon != null
      ? [spacePixPolygon, ...devicesAsPixPolygons, ...combinationOfFireDeviceSquaresPixPolygons]
      : [];
  }, [spacePixPolygon, devicesAsPixPolygons, combinationOfFireDeviceSquaresPixPolygons]);

  return (
    <>
      {allPixPolygons != null && (
        <Stack h="100%" w="100%" p={0}>
          <Flex bg="blue.1" p={0}>
            <span>Antall kombinasjoner: {combinationOfFireDeviceSquares.length}</span>
            <span>
              Gyldige kombinasjoner:
              {combinationOfFireDeviceSquares.filter((comb) => comb.coverAllWalls).length}
            </span>
            <ActionIcon
              variant="default"
              disabled={selectedCombinationIndex === 0}
              size="sm"
              onClick={() => setSelectedCombinationINdex(selectedCombinationIndex - 1)}
            >
              <FaArrowAltCircleLeft />
            </ActionIcon>
            Viser kombinasjon {selectedCombinationIndex + 1}
            <ActionIcon
              variant="default"
              disabled={combinationOfFireDeviceSquares.length === selectedCombinationIndex + 1}
              size="sm"
              onClick={() => setSelectedCombinationINdex(selectedCombinationIndex + 1)}
            >
              <FaArrowAltCircleRight />
            </ActionIcon>
          </Flex>
          <DeckBimViewer
            flip2dCoordinate={true}
            angle={rotation}
            paths={[]}
            polygons={allPixPolygons ?? []}
            goToPolygon={spacePixPolygon?.id}
          />
        </Stack>
      )}
    </>
  );
};

export default SprinklerSquareWallRuleViewer;

const convertFireDeviceSquareBoxesToPixPolygons = (
  fireDeviceBoxesValidation: IFireDeviceSquareBoxesWithCoversValidation
): IPixPolygon[] => {
  return (fireDeviceBoxesValidation?.squares ?? []).map((square) => {
    return {
      id: generateRandomString(5),
      points: square,
      fillColor: fireDeviceBoxesValidation.coverAllWalls ? "green" : "red",
      strokeColor: "#003ef1",
      strokeWidth: "10",
      text: {
        show: false,
        values: [],
        color: "#000000",
        fontSize: "12px",
      },
      isMoveable: false,
      isDragSelectable: false,
      tooltip: "",
      opacity: 0.5,
    };
  });
};
